module.exports = __webpack_public_path__ + "static/img/MarinaPictures124a.bf0e8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/MarinaPictures124a.jpg
// module id = vJ21
// module chunks = 4